import { instance, instanceWithAuth } from "@/api/index";

function login(param) {
    return instance.post("/auth/login", param);
}
function ssoLogin(params) {
    return instance.get("/auth/sso/login", { params: params });
}
function refresh(param) {
    return instance.get("/auth/refresh", {
        params: param
        , skipLoading: true
    },);
}
function extendRefresh(skipLoading) {
    return instanceWithAuth.post("/auth/extend", {}, { skipLoading: skipLoading });
}


export { login, ssoLogin, refresh, extendRefresh };